import React, { useEffect, useState } from "react";
import "./index.css";
import "antd/dist/antd.min.css";
import {
  Layout,
  Menu,
  Breadcrumb,
  Button,
  message,
  Modal,
  Form,
  Input,
} from "antd";
import {
  UserOutlined,
  LaptopOutlined,
  PieChartOutlined,
  ShoppingOutlined,
  MacCommandOutlined,
  DollarOutlined,
} from "@ant-design/icons";
import { menus } from "./constants/menus";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
// import * as userAPI from "./api/user";
import { useRecoilState } from "recoil";
import { authItemState, searchItemState } from "./states/atoms";
import Main from "./page/Main/Main";
import SignIn from "./page/Main/SignIn";


const { Header, Content, Sider } = Layout;

function App() {
  const location = useLocation();
  const navigate = useNavigate();

  const [searchItem, setSearchItem] = useRecoilState(searchItemState);
  const [authItem, setAuthItem] = useRecoilState(authItemState);

  const [selectedMenu, setSelectedMenu] = useState({ title: "메인", path: "" });
  const [selectedSubMenu, setSelectedSubMenu] = useState({
    title: "홈",
    path: "",
  });

  const [isAuthed, setIsAuthed] = useState(false);

  const accessToken = sessionStorage.getItem('accessToken')

  // alert(accessToken)

  useEffect(() => {
    if (accessToken) {
      setIsAuthed(true)
    }
  }, [accessToken])

  const onClickMenu = (mainMenu, subMenu, mainIndex, subIndex) => {
    setSelectedMenu(mainMenu);
    setSelectedSubMenu(subMenu);
    sessionStorage.setItem("page", 1);
    sessionStorage.setItem("query", JSON.stringify({}));
    setSearchItem({});
    navigate(`/${mainMenu?.path}/${subMenu?.path}`);
  };

  useEffect(() => {
    // userAPI
    //   .authCheck()
    //   .then((res) => {
    //     if (res.data.linusCode === 1) {
    //       setIsAuthed(true);
    //       setAuthItem({ isAuthed: true });
    //       return;
    //     } else {
    //       setIsAuthed(false);
    //       setAuthItem({ isAuthed: false });
    //       navigate("/sign-in");
    //     }
    //   })
    //   .catch((error) => {
    //     message.error("로그인이 필요합니다.");
    //     navigate("/sign-in");
    //   });
  }, [location.pathname, setIsAuthed]);

  useEffect(() => {
    if (location.pathname !== "/") {
      let mainPath = location.pathname.split("/")[1];
      let subPath = location.pathname.split("/")[2];

      let menu = menus.filter((m) => m?.mainMenu.path === mainPath)[0];
      let mainMenu = menu?.mainMenu;
      let subMenu = menu?.subMenus.filter((m) => m.path === subPath)[0];

      setSelectedMenu(mainMenu);
      setSelectedSubMenu(subMenu);
    }
  }, [location]);

  const siderItems = [
    UserOutlined,
    ShoppingOutlined,
    // LaptopOutlined,
    PieChartOutlined,
    MacCommandOutlined,
    DollarOutlined,
  ]?.map((icon, index) => {
    return {
      key: `${menus[index]?.mainMenu.title}`,
      icon: React.createElement(icon),
      label: `${menus[index]?.mainMenu.title}`,
      children: menus[index]?.subMenus?.map((subMenu, idx) => {
        return {
          key: `${subMenu.title}`,
          label: `${subMenu.title}`,
          onClick: () =>
            onClickMenu(menus[index]?.mainMenu, subMenu, index, idx),
        };
      }),
    };
  });

  const [form] = Form.useForm();
  const userId = Form.useWatch("userId", form);
  const password = Form.useWatch("password", form);
  const phone = Form.useWatch("phone", form);

  const onClickLogin = (e) => {
    e.preventDefault();
    navigate("/sign-in");
    navigate("/sign-in");
  };

  const [visible, setVisible] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [initialValue, setInitialValue] = useState(null);

  const handleOk = () => {
    setConfirmLoading(true);
    sessionStorage.removeItem("accessToken");

    // userAPI
    //   .loginTemp({ userId, password, phone })
    //   .then((res) => {
    //     if (res.data.linusCode === 1) {
    //       message.success("성공적으로 로그인되었습니다.");
    //       sessionStorage.setItem("accessToken", res.data.data.tokens.accessToken);
    //       setAuthItem({ isAuthed: true });
    //       setIsAuthed(true);
    //       setVisible(false);
    //     } else {
    //       message.error(res.data.data.msg);
    //       setAuthItem({ isAuthed: false });
    //       setIsAuthed(false);
    //     }
    //   })
    //   .catch((error) => {
    //     if (error.response.data.detail) {
    //       message.error(error.response.data.detail);
    //     } else if (error.response.status < 500) {
    //       for (let key of Object.keys(error.response.data)) {
    //         message.error(`${key}: ${error.response.data[key]}`);
    //       }
    //     } else {
    //       message.error("오류가 발생했습니다.");
    //     }
    //   });
  };

  const onClickLogout = (e) => {
    e.preventDefault();
    sessionStorage.removeItem("accessToken");
    sessionStorage.removeItem("email");
    setIsAuthed(false);

    // userAPI
    //   .authCheck()
    //   .then((res) => {
    //     if (res.data.linusCode === 1) {
    //       setIsAuthed(true);
    //       setAuthItem({ isAuthed: true });
    //       return;
    //     } else {
    //       setIsAuthed(false);
    //       setAuthItem({ isAuthed: false });
    //       navigate("/sign-in");
    //     }
    //   })
    //   .catch((error) => {
    //     message.error("로그인이 필요합니다.");
    //     navigate("/sign-in");
    //   });
  };

  useEffect(() => {
    if (!isAuthed) {
      // navigate('/sign-in')
    }
  }, [isAuthed])

  const handleCancel = () => {
    setVisible(false);
  };

  const goBack = () => {
    navigate(-1)
  }

  const email = sessionStorage.getItem('email')

  return (
    <Layout>
      {/* <Modal
        width={400}
        title={`로그인`}
        visible={visible}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
        footer={[
          <Button key="back" onClick={handleCancel}>
            취소
          </Button>,
          <Button key="submit" type="primary" onClick={handleOk}>
            확인
          </Button>,
        ]}
      >
        <Form form={form}>
          <Form.Item name="userId" label="아이디">
            <Input placeholder="아이디를 입력하세요" />
          </Form.Item>
          <Form.Item name="password" label="패스워드">
            <Input placeholder="패스워드를 입력하세요" type={"password"} />
          </Form.Item>
          <Form.Item name="phone" label="휴대폰 번호">
            <Input placeholder="휴대폰 번호를 입력하세요" type={"phone"} />
          </Form.Item>
        </Form>
      </Modal> */}
      <Header
        className="header"
        style={{
          display: "flex",
          background:"cornflowerblue",
        }}
      >
        {/*<div onClick={goBack} style={{color: '#fff', width: 100}}>{'<'} 뒤로가기</div>*/}
        <div
          className="logo"
          style={{
            color: "white",
            fontWeight: 800,
            fontSize: "1.5em",
            cursor: "pointer",
            display: "flex",
            width: "50%",
          }}
          onClick={() => {
            setSelectedMenu({
              title: "메인",
              path: "",
            });
            setSelectedSubMenu({
              title: "홈",
              path: "",
            });
            navigate("/");
          }}
        >
          인컬리지 관리자
        </div>
        <div style={{color: '#fff', minWidth: 200}}>
          {email ? `${email}` : '로그아웃 상태입니다.'}
        </div>
        <div
          className="logo"
          style={{
            color: "white",
            fontWeight: 800,
            fontSize: "1.5em",
            cursor: "pointer",
            display: "flex",
            justifyContent: "end",
            alignItems: "center",
            width: "50%",
          }}
        >
          {!isAuthed && (
            <Button ghost onClick={onClickLogin}>
              로그인
            </Button>
          )}
          {isAuthed && (
            <Button ghost onClick={onClickLogout}>
              로그아웃
            </Button>
          )}
        </div>
      </Header>
      <Layout>
        {isAuthed ?
          <Sider width={200} className="site-layout-background">
            <Menu
              mode="inline"
              defaultSelectedKeys={["1"]}
              defaultOpenKeys={["sub1"]}
              style={{
                height: "100%",
                borderRight: 0,
              }}
              items={siderItems}
            />
          </Sider>
          : null
        }
        <Layout
          style={{
            padding: "0 24px 24px",
          }}
        >
          <Breadcrumb
            style={{
              margin: "40px 0 0 0",
            }}
          >
            <Breadcrumb.Item>{selectedMenu?.title}</Breadcrumb.Item>
            <Breadcrumb.Item>{selectedSubMenu?.title}</Breadcrumb.Item>
          </Breadcrumb>

          <Content
            className="site-layout-background"
            style={{
              padding: 24,
              margin: "30px 30px 0px 30px",
              minHeight: 800,
              backgroundColor: "white",
            }}
          >
            <Routes>
              {/* <Route path="/" element={isAuthed ? <HomePage /> : <></>} /> */}
              {menus.map((menu) =>
                menu?.subMenus.map((subMenu) => (
                  <Route
                    path={`/${menu.mainMenu.path}/${subMenu.path}/*`}
                    element={subMenu.page}
                  />
                ))
              )}
              <Route path={`/sign-in`} element={<SignIn />} />
              <Route path={`/`} element={<Main />} />
            </Routes>
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
}

export default App;
